import http from './http'
import axios from 'axios'
import Cookies from 'js-cookie'

export async function getUserDetails({ userId }) {
  return http.get(`/user/user-details/${userId}`, {})
}

let cancelToken

export async function getUserDetailsByEntity(userId, entityName) {
  if (typeof cancelToken !== typeof undefined) {
    cancelToken.cancel('Operation canceled due to new request.')
  }
  cancelToken = axios.CancelToken.source()
  return http.get(`/user/user-details/${userId}?entityName=${entityName}`, {
    cancelToken: cancelToken.token
  })
}

export async function getProducts({ userId, entityId }) {
  return http.get(`/resource/filter?UserId=${userId}&EntityId=${entityId}`, {})
}

export function changeContract(entityLegacyId) {
  Cookies.set('active-contract', entityLegacyId, {
    domain: '.clearsale.com.br'
  })
}
